import ContainerFullHeight from "components/ContainerFullHeight/ContainerFullHeight";
import React from "react";
import style from "./BonusSectionStyle";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import { Typography } from "@material-ui/core";

import premium from "../../../../assets/img/25/Bonus/Premium.png";
import acompañamiento from "../../../../assets/img/25/Bonus/Acompañamiento.png";
import networking from "../../../../assets/img/25/Bonus/Networking.png";
import plan from "../../../../assets/img/25/Bonus/Plan de Pago.png";

const useStyles = makeStyles(style);

export default function BonusSection({ id, t }) {
  const classes = useStyles();

  return (
    <ContainerFullHeight
      bgColor="white"
      paddingTop="100px"
      paddingBottom="100px"
      justifyContent="center"
    >
      <div className={classes.container}>
        <h1 className={classes.title}>{t("bonusSectionTitle")}</h1>
        <GridContainer className={classes.bonusContainer}>
          <GridItem xs={6} sm={6} md={2} className={classes.bonusItem}>
            <img
              src={premium}
              alt="Icono premium"
              height="102px"
              style={{ marginBottom: "30px" }}
            />
            <Typography className={classes.bonusItemText}>
            {t("bonusSubtitle1")}
            </Typography>
          </GridItem>
          <GridItem xs={6} sm={6} md={2} className={classes.bonusItem}>
            <img
              src={acompañamiento}
              alt="Icono acompañamiento"
              height="102px"
              style={{ marginBottom: "30px" }}
            />
            <Typography className={classes.bonusItemText}>
            {t("bonusSubtitle2")}
            </Typography>
          </GridItem>
          <GridItem xs={6} sm={6} md={2} className={classes.bonusItem}>
            <img
              src={networking}
              alt="Icono networking"
              height="102px"
              style={{ marginBottom: "30px" }}
            />
            <Typography className={classes.bonusItemText}>
            {t("bonusSubtitle3")}
            </Typography>
          </GridItem>
          <GridItem xs={6} sm={6} md={2} className={classes.bonusItem}>
            <img
              src={plan}
              alt="Icono plan de pago"
              height="102px"
              style={{ marginBottom: "30px" }}
            />
            <Typography className={classes.bonusItemText}>
            {t("bonusSubtitle4")}
            </Typography>
          </GridItem>
        </GridContainer>
      </div>
    </ContainerFullHeight>
  );
}
